import React, {useState} from "react";
import "./index.css";
import cn from "classnames";
import Textarea from "../../../layout/Textarea/Textarea";
import ImageUpload from "../../../layout/ImageUpload/index";
import {logoNorm, logoIDE, UI} from "../../../data/constants";
import {checkIfIDE} from "../../../data/products/index";
import Icon from "../../../layout/Icon";
import BgTransformer from "../../../layout/BgTransformer";
import PixelationLayer from "../../../layout/PixelationLayer";
import BannerButton from "../../../layout/BannerButton";
import {useSetting} from "../../../contexts/setting";
import {useEdits} from "../../../contexts/edits";
import {useBgUrl} from "hooks/useBgUrl";

const Email02 = ({id, zoom}) => {
  const {product, layoutOption, iconOption} = useSetting();
  const {url: bgUrl} = useBgUrl();
  const {titles, subtitles, badges} = useEdits();
  const [isInline, setIsInline] = useState(true);

  const title = titles[id] || titles.main;
  const badge = badges[id] || badges.main;
  const templateClass = cn("template", `layout-${layoutOption}`);

  return (
    <>
      <div id={id} className={templateClass} style={{"--zoom-level": zoom}}>
        <div>
          <BgTransformer src={bgUrl} id={id} />
          <PixelationLayer />

          <div className="content">
            <div className="title-wrap">
              <h1 className="title">
                <Textarea id={id} text={title} />
              </h1>
              {+layoutOption === 3 && (
                <BannerButton id={id} className="badge">
                  <Textarea id={id} text={badge} inline={isInline} />
                </BannerButton>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Email02;
